export function hydrateSimulators(ss, jq) {
  return ss.map(s => Object.assign({}, s, {
    jobQueue: jq.find(q => q.id === s.jobQueue?.id)
  }));
}
